var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"vue-tinymce"}},[_c('vue-tinymce',{attrs:{"setting":_vm.setting},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }